import { Component, Input, OnInit } from '@angular/core';
import { UscStoreService } from '../../../services/usc-store/usc-store.service';
import { AuthService, CalendarService, TranslatorService } from '../../../services';

@Component({
    selector: 'sn-usc-monthly-sales-panel-advanced',
    templateUrl: './usc-monthly-sales-panel-advanced.component.html',
    styleUrls: ['./usc-monthly-sales-panel-advanced.component.css']
})
export class UscMonthlySalesPanelAdvancedComponent implements OnInit {
    @Input() sales_mode: string;
    @Input() scope_type: string;
    @Input() scope_value: string;
    @Input() scope_user: any;           //NOTE: scope_user changes depending on current month or previous month.  current month it is of type cosultant_achievement whereas previous month it is of type action_plan
    @Input() scope_month: string;

    public p2w_goal_exceeded:number = 0;
    public p2w_quota_exceeded:number = 0;
    public isLeader: boolean;
    public isSalesVsQuota: boolean = false;
    public isSalesVsGoal: boolean = false;
    public isConsultant: boolean = false;
    public is_current_month: boolean = true;
    public is_sales_metrics_loaded: boolean = false;
    public sales_metrics: any[] = [];
    public total_estimated_payout:number;
    public total_pacing_payout:number;
    public is_payout_estimate_loaded:boolean = false;
    public last_sales_extract:any;
    
    drivers: any[] = [
        { mtd: 0, quota: 0, mtd_quota_pct: "0", incentive: 0, incentive_earned: 0, kicker_value: 0, kicker_earned: 0, payout: 0, driver: "postpaid", label: "Postpaid" },
        { mtd: 0, quota: 0, mtd_quota_pct: "0", incentive: 0, incentive_earned: 0, kicker_value: 0, kicker_earned: 0, payout: 0, driver: "other_volume", label: "Other Volume" },
        { mtd: 0, quota: 0, mtd_quota_pct: "0", incentive: 0, incentive_earned: 0, kicker_value: 0, kicker_earned: 0, payout: 0, driver: "revenue", label: "Revenue" },
        { mtd: 0, quota: 0, mtd_quota_pct: "0", incentive: 0, incentive_earned: 0, kicker_value: 0, kicker_earned: 0, payout: 0, driver: "upgrades", label: "Upgrades" },
        { mtd: 0, quota: 0, mtd_quota_pct: "0", incentive: 0, incentive_earned: 0, kicker_value: 0, kicker_earned: 0, payout: 0, driver: "high_msrp_accessories", label: "High MSRP Accessories",},
    ];

    constructor(
        public uscStoreService: UscStoreService,
        public calendarService: CalendarService,
        public translatorService: TranslatorService,
        public authService: AuthService,
    ) { }

    
    ngOnInit() {
        this.last_sales_extract = this.uscStoreService.last_sales_extract;
        this.isLeader = this.uscStoreService.isLeader();
        if (this.scope_month == undefined) this.scope_month = this.uscStoreService.getThisMonthActionPlanSubject();
        this.is_current_month = this.scope_month == this.uscStoreService.getThisMonthActionPlanSubject();
        this.isSalesVsQuota = this.isLeader && this.sales_mode == 'quota';
        this.isSalesVsGoal = this.isLeader && this.sales_mode == 'goal';
        var dataset_type = this.isSalesVsQuota ? "monthly_sales_vs_quota" : "monthly_sales_vs_goal";
        this.isConsultant = this.scope_type == "associate";
        if (this.isLeader) {
            this.uscStoreService.getP2WSalesMetrics(dataset_type, this.scope_type, this.scope_value).subscribe(result => {
                this.sales_metrics = result;
                this.is_sales_metrics_loaded = true;
                this.analyzeSalesMetrics();
                if (this.isConsultant) this.calculatePayoutEstimates();
            });
        } else {
            this.uscStoreService.getP2WSalesMetrics(dataset_type).subscribe(result => {
                this.sales_metrics = result;
                this.is_sales_metrics_loaded = true;
                this.analyzeSalesMetrics();
                this.calculatePayoutEstimates();
            });
        }
    }

    calculatePayoutEstimates() {
        if (this.is_current_month) {
            if (this.uscStoreService.isUSCellCorp() || this.uscStoreService.isUSCellTelesales()) {
                this.uscStoreService.getPayoutEstimatorMetrics("this_month", this.scope_type, this.scope_value).subscribe(metrics => {
                    var pacing_sales_estimate = metrics.find(m => m.dataset_type == "pacing_sales_estimate");
                    var actual_sales_estimate = metrics.find(m => m.dataset_type == "actual_sales_estimate");
                    this.total_pacing_payout = pacing_sales_estimate.value;
                    this.total_estimated_payout = actual_sales_estimate.value;
                    this.is_payout_estimate_loaded = true;
                })
            } else {
                // this.uscStoreService.getThisMonthPayoutEstimate(this.drivers, this.action_plan, this.days_remaining).subscribe(
                //     result => {
                //         this.total_estimated_payout = result.total_estimated_payout;
                //         this.total_pacing_payout = result.total_pacing_payout;
                //     }
                // )
            }
        }        
    }

    analyzeSalesMetrics() {
        this.sales_metrics.forEach(m => {
            if (this.isSalesVsGoal && m.goal_pct >= 1) this.p2w_goal_exceeded++;
            if (this.isSalesVsQuota && m.quota_pct >= 1) this.p2w_quota_exceeded++;
        })
    }

    gotoDetailedResults() {
        if (this.scope_type == undefined) {
            this.uscStoreService.setCurrentView(this.uscStoreService.view_p2w_associate_detailed_results);
        } else {
            var dr_view = this.isSalesVsGoal ? this.uscStoreService.view_p2w_goal_gross_adds_detail_results : this.uscStoreService.view_p2w_quota_gross_adds_detail_results;
            this.uscStoreService.setCurrentDetailResultScope({ scope_type: this.scope_type, scope_value: this.scope_value })
            this.uscStoreService.setCurrentView(dr_view);
        }
    }

    showAssociateDetailedResults(): boolean {
        return !this.uscStoreService.isLeader();
    }

    getTitle() {
        // consultant view: scope_type == null
        if (this.scope_type == null) return this.is_current_month ? "How this month is shaping up?" : "How this month shaped up.";

        var format = "_MM_ - _ST_ _SV_";
        var mm = this.is_current_month ? "This Month" : this.calendarService.getMonthName(parseInt(this.scope_month.substring(4)) - 1);
        if (this.isConsultant) {
            return mm + " - " + (this.is_current_month ? this.scope_user.AssociateName : this.scope_user.ur_associate_name);
        } else if (this.uscStoreService.isLeader()) {
            var st = this.scope_type == "channel" ? "National" : (this.scope_type == "agency" ? "Agency" : "Team");
            return format.replace("_MM_", mm).replace("_ST_", st).replace("_SV_", this.scope_value);
        }
    }

    getDesc():string {
        var progress = "", desc = "";
        // leader's member view
        if (this.scope_type == 'associate') {
            if (!this.is_current_month) {
                if (this.isSalesVsQuota) return "_USER_ surpassed __QUOTAS__ of their Plan2Win quota(s).".replace('_USER_', this.scope_user.ur_associate_name).replace('__QUOTAS__', this.p2w_quota_exceeded.toString());
                if (this.isSalesVsGoal) return "_USER_ surpassed __GOALS__ of their Plan2Win goal(s).".replace('_USER_', this.scope_user.ur_associate_name).replace('__GOALS__', this.p2w_goal_exceeded.toString());
            } else {
                if (this.isSalesVsQuota) progress = "_USER_ is ahead on __QUOTAS__ of their Plan2Win quota(s).".replace('_USER_', this.scope_user.AssociateName).replace('__QUOTAS__', this.p2w_quota_exceeded.toString());
                if (this.isSalesVsGoal) progress = "_USER_ is ahead on __AHEAD__ of their Plan2Win goal(s).".replace('_USER_', this.scope_user.AssociateName).replace('__AHEAD__', this.p2w_goal_exceeded.toString());
            }
        } if (!this.isLeader) {
            // associate view
            if (!this.is_current_month) {
                if (this.isSalesVsQuota) progress = "Congratulations, you have surpassed __QUOTAS__ of your Plan2Win goals.".replace('__QUOTAS__', this.p2w_quota_exceeded.toString());
                if (this.isSalesVsGoal) progress = "Congratulations, you have surpassed __GOALS__ of your Plan2Win goals.".replace('__GOALS__', this.p2w_goal_exceeded.toString());
                desc = "Here's how __MONTH__ shaped up after you've worked __DW__ of your __DS__ scheduled days this month:";
            } else {
                if (this.isSalesVsQuota) progress = "Congratulations, you are ahead on __QUOTAS__ of your Plan2Win goal(s). ".replace('__QUOTAS__', this.p2w_quota_exceeded.toString());
                if (this.isSalesVsGoal) progress = "Congratulations, you are ahead on __AHEAD__ of your Plan2Win goal(s). ".replace('__AHEAD__', this.p2w_goal_exceeded.toString());
                desc = "Here's how __MONTH__ is shaping up after you've worked __DW__ of your __DS__ scheduled days this month:";
            }
            var month = (new Date()).getMonth();
            if (!this.is_current_month) month = parseInt(this.scope_month.substring(4, 6)) - 1;
            desc = desc.replace('__MONTH__', this.calendarService.getMonthName(month)).replace('__DW__', '999').replace('__DS__', '999');
        }
        if (this.isSalesVsGoal) return (this.p2w_goal_exceeded > 0)  ? progress + desc : desc;
        if (this.isSalesVsQuota) return (this.p2w_quota_exceeded > 0)  ? progress + desc : desc;
        return "";
    }

    getUnavailableDesc(): string {
        var desc = "";
        // var name = this.scope_user == null ? this.current_user.first_name + ' ' + this.current_user.last_name : this.scope_user.ur_associate_name;
        // if (this.is_action_plan_unavailable) desc = "Unable to retrieve current user's sales figures.".replace('_NAME_', name);
        return desc;
    }

    gotoSubTeam() {
        var prev_scope_type = this.scope_type;
        var prev_scope_value = this.scope_value;
        var next_scope_type = "";
        if (this.scope_type == "store") {
            this.uscStoreService.setP2wTeamSalesTrackerScope({ next_scope_type: "user", prev_scope_type: prev_scope_type, prev_scope_value: prev_scope_value });
        }
        else {
            // first determine the next_scope_type
            if (this.scope_type == "channel") next_scope_type = "region";
            else if (this.scope_type == "region") next_scope_type = "territory";
            else if (this.scope_type == "territory") next_scope_type = "area";
            else if (this.scope_type == "area") next_scope_type = "store";
            else if (this.scope_type == "agency") next_scope_type = "store";
            this.uscStoreService.setP2wTeamSalesTrackerScope({ next_scope_type: next_scope_type, prev_scope_type: prev_scope_type, prev_scope_value: prev_scope_value });
        }
    }

    isPayoutEstimateEnabled():boolean {
        if (this.uscStoreService.isUSCellAgent()) return false;
        return this.is_current_month && (!this.isLeader || this.isConsultant);
    }
}



// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/usc-store/usc-monthly-sales-panel-advanced/usc-monthly-sales-panel-advanced.component.ts